import React from 'react';
import { FlatList, Modal } from "react-native";
import type { BracketGroupProps, BracketRoundProps } from '../../../types';
import { Checkbox } from '../../../Components';
import { Button, Text, View } from '../../../Components/Themed';
import { useColors } from '../../../constants/useColors';

type BracketNavigatorProps = {
    visible:boolean,
    view_mode?:'desktop'|'mobile',
    insets?:{ top:number, bottom:number, left:number, right:number },
    bracket_rounds:BracketRoundProps[],
    bracket_groups:BracketGroupProps[],
    selected_round?:BracketRoundProps,
    selected_group?:BracketGroupProps,
    onSelectRound:(r:BracketRoundProps) => void,
    onSelectGroup:(g:BracketGroupProps) => void,
    onClose: () => void
}

const nav_sections = [ 'groups', 'rounds' ];
const BracketNavigator = ({ visible, view_mode, insets, bracket_rounds, bracket_groups, selected_round, selected_group, onSelectGroup, onSelectRound, onClose }:BracketNavigatorProps) => {
    const Colors = useColors();
    const renderRounds = (data : { item:BracketRoundProps, index:number }) => {
        const selected = selected_round?.bracket_round_id == data.item.bracket_round_id ? true : false
        return (
            <Button style={{ flexDirection:'row', borderRadius:0, alignItems:'center', padding:16,  borderBottomWidth:1, borderColor:Colors.borders.light }} onPress={() => onSelectRound(data.item)}>
                <Checkbox size={20} fill_style={{ borderRadius:100 }} style={{ borderRadius:100, marginRight:15 }} color={Colors.text.action} checked={selected} disabled onSelect={() => console.log('')}/>
                <Text size={14} theme={selected?'h1':'description'}>{data.item.round_name}</Text>
            </Button>
        )
    }

    const renderGroups = (data : { item:BracketGroupProps, index:number }) => {
        const selected = selected_group?.bracket_group_id == data.item.bracket_group_id ? true : false
        return (
            <Button style={{ flexDirection:'row', alignItems:'center', borderRadius:0, padding:16, borderBottomWidth:1, borderColor:Colors.borders.light }} onPress={() => onSelectGroup(data.item)}>
                <Checkbox size={20} fill_style={{ borderRadius:100 }} style={{ borderRadius:100, marginRight:15 }} color={Colors.text.action} checked={selected} disabled onSelect={() => console.log('')}/>
                <Text size={14} theme={selected?'h1':'description'}>{data.item.group_name}</Text>
            </Button>
        )
    }

    const renderSections = (data:{item:string, index:number}) => {
        switch(data.item){
            case 'groups':
                return (
                    <View style={{ marginTop:5 }}>
                        <View type='header' style={{ padding:10 }}>
                            <Text theme='h1'>Groups</Text>
                            <Text theme='description' style={{ marginTop:4 }}>Select bracket group filter below</Text>
                        </View>
                        <FlatList
                            data={bracket_groups}
                            renderItem={renderGroups}
                            keyExtractor={(item) => item.bracket_group_id.toString()}
                        />
                    </View>
                )
            case 'rounds':
                return (
                    <View style={{ marginTop:5 }}>
                        <View type='header' style={{ padding:10 }}>
                            <Text theme='h1'>Rounds</Text>
                            <Text theme='description' style={{ marginTop:4 }}>Select round filter below</Text>
                        </View>
                        <FlatList
                            data={bracket_rounds}
                            renderItem={renderRounds}
                            keyExtractor={(item) => item.bracket_round_id.toString()}
                        />                            
                    </View>
                )
            default: return <></>
        }
    }

    return (
        <Modal
            visible={visible}
            style={{ flex:1 }}
            transparent
            animationType={view_mode == 'desktop' ? 'fade' : 'slide'}
            >
            <View type='blur' style={view_mode == 'desktop' ? { flex:1, justifyContent:'center', alignItems:'center' } : { flex:1, justifyContent:'flex-end', paddingBottom:(insets?.bottom ?? 0) }}>
                <View float style={view_mode == 'desktop' ? {  width:500 }:{ margin:10, maxHeight:650 }}>
                    <View type='header' style={{ padding:10, flexDirection:'row', alignItems:'center', borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                        <Text style={{ flex:1 }} size={14} theme='h1'>Bracket Filters</Text>
                        <Button
                            title='X'
                            type='close'
                            style={{ padding:10 }}
                            backgroundColor='transparent'
                            onPress={() => onClose()}
                        />
                    </View>
                    <FlatList
                            key='nav_sections'
                            keyExtractor={(item) => item}
                            renderItem={renderSections}
                            data={nav_sections}
                        />                       
                    <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                        <Button
                            type='close'
                            title='CLOSE'
                            style={{ flex:1 }}
                            onPress={() => onClose()}
                        />
                    </View>
                </View>
                </View>
        </Modal>
        
    )
}

export default BracketNavigator